<template>
  <div class="total-grid-container">
    <Chat />
    <div class="total-title"><h1>CLASSEMENT</h1></div>
    <div class="total-winner">
      <h1>{{ winner.name }}</h1>
      <img src="/crowns.png" alt="crown" class="crown" />
      <img :src="avatars[winner.avatar]" alt="avatar" class="winner_avatar" />
      <h2>{{ winner.points }} pts</h2>
    </div>
    <div class="total-loosers">
      <div
        class="looser"
        v-for="(looser, i) in loosers"
        :key="i"
        :style="`width: calc(100vw / ${nbOfPlayers});`"
      >
        <h2 :style="`width: calc(100vw / ${nbOfPlayers});`">
          {{ looser.name }}
        </h2>
        <img :src="avatars[looser.avatar]" alt="avatar" />
        <h3>{{ looser.points }}</h3>
      </div>
    </div>
    <div class="total-actions">
      <button v-if="isHost" class="button is-medium is-link" @click="restart()">
        retour au lobby
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Chat from "@/components/Chat.vue";

export default {
  name: "Total",
  components: {
    Chat
  },
  methods: {
    restart() {
      this.sendMessageToRoom("newGame");
    }
  },
  computed: {
    ...mapState("colyseus", ["playerById"]),
    ...mapState(["avatars"]),
    ...mapGetters("colyseus", ["isHost", "self"]),
    rank() {
      let ranking = [];
      for (let id in this.playerById) {
        ranking.push(this.playerById[id]);
      }
      ranking = ranking.sort((a, b) => b.points - a.points);
      return ranking;
    },
    winner() {
      return this.rank[0];
    },
    loosers() {
      return this.rank.slice(1);
    },
    nbOfPlayers() {
      return Object.keys(this.playerById).length;
    },
    hasWon() {
      return this.self.sessionId == this.winner.sessionId;
    }
  }
};
</script>

<style lang="scss" scoped>
.total-grid-container {
  display: grid;
  grid-template-columns: 1.4fr 0.6fr 1.4fr;
  grid-template-rows: auto auto auto auto;
  gap: 1px 1px;
  grid-template-areas: "total-title total-title total-title" ". total-winner ." "total-loosers total-loosers total-loosers" "total-actions total-actions total-actions";
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  height: auto;
}

.total-title {
  grid-area: total-title;
}

.crown {
  position: relative;
  width: 5vmin;
}

.total-winner {
  grid-area: total-winner;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.winner_avatar {
  width: 15vmin;
  @media only screen and (max-width: 800px) {
    width: 20vmin;
  }
}

.total-loosers {
  grid-area: total-loosers;
  display: flex;
  justify-content: space-around;
  @media only screen and (max-width: 800px) {
    flex-direction: column;
    justify-content: start;
  }
}

.total-actions {
  grid-area: total-actions;
}

.looser > img {
  width: 10vmin;
  @media only screen and (max-width: 800px) {
    width: 15vmin;
  }
}

.looser > h2 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media only screen and (max-width: 800px) {
    width: 100% !important;
  }
}

.looser {
  @media only screen and (max-width: 800px) {
    width: 100% !important;
  }
}
</style>
